import { Toast } from "vant";
  // 打包前看readme文件
export const mixins = {
  data() {
    return {
      urlList: [
        { time: 0, name: '欲漫涩', url: 'https://dfybs36gmscxa.cloudfront.net', webUrl: 'https://d1s8wm47asyysy.cloudfront.net' },
        { time: 0, name: '萝莉岛', url: 'https://d3ablhhsm5rfcy.cloudfront.net', webUrl: 'https://d1q6v0m0fmxvl0.cloudfront.net' },
        { time: 0, name: '麻豆', url: 'https://dh4c7syhvfjc3.cloudfront.net', webUrl: 'https://d2m1d86x8ze4id.cloudfront.net' },
        { time: 0, name: '海角乱伦', url: 'https://d38gy0w8sl85ig.cloudfront.net', webUrl: 'https://doyj68zud8dgm.cloudfront.net' },
        { time: 0, name: 'pornhub中文版', url: 'https://d1dh9hj1dthzwj.cloudfront.net', webUrl: 'https://d2o7c2qy2lvgf1.cloudfront.net' },
        { time: 0, name: 'xvideos', url: 'https://d26eibx2n2wmam.cloudfront.net', webUrl: 'https://d4yzu2s8mrrvk.cloudfront.net' },

        { time: 0, name: '91porn', url: 'https://d31yw0qcadxca4.cloudfront.net'},
        { time: 0, name: '萝莉岛', url: 'https://d18kjrkz2vte27.cloudfront.net', webUrl: 'ttps://d2xw96fnbwxopk.cloudfront.net'},
        { time: 0, name: 'pornhub精品版', url: 'https://d1pd5il8jtsg9b.cloudfront.net' },
        { time: 0, name: '妖精漫画', url: 'https://d2qz74284n1cau.cloudfront.net/' },
        { time: 0, name: '糖心视频', url: 'https://d3d2sv0sm1r7sp.cloudfront.net' },
        { time: 0, name: '91暗网', url: 'https://d3hje5u27lemy9.cloudfront.net', webUrl: 'https://dh0n7f6bcnjxj.cloudfront.net' },
        { time: 0, name: '好色', url: 'https://d1zhn2q3mcgwo.cloudfront.net', webUrl: 'https://d39cmeitkp3imu.cloudfront.net' },
        { time: 0, name: 'Soul', url: 'https://d6atw0mbstf8l.cloudfront.net', webUrl: 'https://d1u1x3yp88ozd.cloudfront.net' },
        { time: 0, name: '逼哩逼哩', url: 'https://d27ja3di1pudwk.cloudfront.net' },
        { time: 0, name: '哆哔涩漫', url: 'https://d2v53pj1wsca2c.cloudfront.net'},

        { time: 0, name: 'XVideos破解版', url: 'https://d2agz30h3mlj85.cloudfront.net' },
        { time: 0, name: '波多', url: 'https://d2tkp94qj5fqzg.cloudfront.net' },
        { time: 0, name: '妻友', url: 'https://d1j6j8l0a7077i.cloudfront.net' },

        { time: 0, name: '快手', url: 'https://d1yah679zvtryi.cloudfront.net' },
        { time: 0, name: 'XV暗网', url: 'https://d1ehuhcr4v8foe.cloudfront.net/' },
         { time: 0, name: '黑料社', url: 'https://d39mdlzxpgfnf9.cloudfront.net/' },
        { time: 0, name: '腾讯涩漫', url: 'https://dowd2imgno97g.cloudfront.net/' },
        { time: 0, name: '泡芙视频', url: 'https://d2dg02yz4ezcz8.cloudfront.net/' },
      ],
      ping: 1,
      timer: null,
      showImg: true,
      addressUrl: "cao.gg",
    };
  },
  mounted() {
    this.addressUrl = window.location.host;
    this.$nextTick(() => {
      this.init();
    });
  },
  methods: {
    init() {
      this.timer = setInterval(() => {
        this.ping++;
      }, 100);
    },
    autoTest(item, index) {
      if (this.ping <= 10) {
        item.time = this.ping * 10;
      } else {
        item.time = this.ping * 100;
      }
      if (index == this.urlList.length - 1) {
        clearInterval(this.timer);
      }
    },
    jumpUrl(url) {
      const routeDc = this.$route.query.dc
      if (routeDc) {
        window.open(url + '?dc=' + routeDc);
      } else {
        const dc = process.env.VUE_APP_WEB_DC || 985
        window.open(url + '?dc=' + dc);
      }
    },
    reset() {
      this.urlList = this.urlList.map((item) => {
        item.time = 0;
        return item;
      });
      this.showImg = false;
      this.$nextTick(() => {
        this.showImg = true;
      });
      this.ping = 1;
      this.init();
    },
    doCopy() {
      let req = this.addressUrl;
      this.$copyText(req).then(
        () => {
          Toast("复制成功");
        },
        () => {
          Toast("复制失败");
        }
      );
    },
  },
};
